import axios from "axios";

export default function editSystemSettings(updateObject, jwt) {
  return new Promise((resolve, reject) => {
    const backend_url = process.env.REACT_APP_BACKEND_URL;
    let target = `${backend_url}/system-settings/`;

    axios({
      url: target,
      method: "PUT",
      data: updateObject,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
      .then((res) =>
        resolve({
          data: res.data,
          error: false,
          complete: true,
        })
      )
      .catch((e) => {
        reject({
          data: null,
          error: true,
          errorMessage: e.response.data,
          complete: true,
        });
      });
  });
}
